import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import formatMoney from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'
import { Typography } from 'gu-ui-kit'

export const Total = ({ deposit = null }) => {
  if (!deposit) {
    return null
  }
  const { payment = {}, label } = deposit
  const { t } = useTranslation(['billing'])
  const { value = null, currency } = payment

  if (value === null) {
    return null
  }

  return (
    <>
      <Typography
        variant={'Body-20'}
        component={'p'}
      >
        {t(label || 'final_amount')}
      </Typography>
      <Typography
        variant={'Body-Accent-60'}
        className={styles['billing__total-with-commission-sum']}
        dangerouslySetInnerHTML={{
          __html: formatMoney(value, currency),
        }}
      />
    </>
  )
}

Total.propTypes = {
  deposit: PropTypes.shape({
    label: PropTypes.string,
    payment: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number]),
      currency: PropTypes.oneOf(CURRENCIES),
    }),
  }),
}
